import { render, staticRenderFns } from "./TableToggleButton.vue?vue&type=template&id=52f8436e&scoped=true&"
import script from "./TableToggleButton.vue?vue&type=script&lang=js&"
export * from "./TableToggleButton.vue?vue&type=script&lang=js&"
import style0 from "./TableToggleButton.vue?vue&type=style&index=0&id=52f8436e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f8436e",
  null
  
)

export default component.exports